import { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

import Chrome from "../textures/Chrome";
import Sound from "./Sound";

const Three = (props) => {
  const { collectables, isMuted, enterButton} = props;
  const [index] = useState(2);

  const group = useRef();
  const { nodes } = useGLTF("./assets/models/three.gltf");

  useFrame(({ clock }) => {
    const t = clock.getElapsedTime();
    if (collectables[index].isComplete) {
      group.current.rotation.y += 0.01;
      group.current.position.y = group.current.position.y + Math.sin(t) * 0.004;
    }
  });

  return (
    <group
      ref={group}
      position={[-0, 4, -40]}
      rotation={[0, -Math.PI / 2, 0]}
      scale={[
        collectables[index].percentageHovered / 200 + 0.6,
        collectables[index].percentageHovered / 200 + 0.6,
        collectables[index].percentageHovered / 200 + 0.6,
      ]}
    >
      <mesh
        userData={{
          index: index,
        }}
        visible={false}
      >
        <sphereGeometry args={[3, 32, 16]} />
      </mesh>
      <mesh
        name="BezierCurve015"
        castShadow
        receiveShadow
        geometry={nodes.BezierCurve015.geometry}
        userData={{
          index: index,
        }}
      >
        <Chrome emissive={collectables[index].isComplete} />
        <Sound 
        url={"./assets/audio/Stem_Pads.mp3"} 
        state={isMuted}
        enterButton={enterButton}
        />
      </mesh>
    </group>
  );
};

export default Three;
useGLTF.preload("./assets/models/three.gltf");
